module.exports = __webpack_public_path__ + "static/media/gold-miner-tom.82adfd8c.jpg";